import { orchestrator } from 'satcheljs';
import toggleIgnoreConversations, {
    internalToggleIgnoreConversations,
} from '../actions/toggleIgnoreConversations';
import PontType from 'owa-service/lib/contract/PontType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { IgnoreConversationsConfirmDialog } from 'owa-mail-ignore-view';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import ignoreConversationsService from '../services/ignoreConversationsService';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { DeleteConversationStoreUpdate, actionNames } from 'owa-mail-store-actions';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import updateUserConfigurationPont from '../actions/actionCreators/updateUserConfigurationPont';
import { userMailInteractionAction } from 'owa-mail-actions';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { processApplyConversationActionResponseMessage } from 'owa-mail-triage-action-response-processor';

export default orchestrator(toggleIgnoreConversations, actionMessage => {
    const shouldIgnore = actionMessage.shouldIgnore;
    const rowKeysToIgnore = actionMessage.rowKeysToIgnore;

    const pontType: PontType = shouldIgnore
        ? PontType.IgnoreConversation
        : PontType.CancelIgnoreConversation;

    // show dialog if pont is set
    if ((pontType & getUserConfiguration().UserOptions.NewEnabledPonts) == pontType) {
        let dialogTitle: string;

        if (shouldIgnore) {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? strings.ignore_ignoreDialogTitle
                    : format(strings.ignore_ignoreDialogTitleNItems, rowKeysToIgnore.length);
        } else {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? strings.ignore_stopIgnoringDialogTitle
                    : format(strings.ignore_stopIgnoringDialogTitleNItems, rowKeysToIgnore.length);
        }
        const dialogText = shouldIgnore
            ? strings.ignore_ignoreDialogSubtext
            : strings.ignore_stopIgnoringDialogSubtext;

        const dialog = new IgnoreConversationsConfirmDialog(
            dialogTitle,
            dialogText,
            checked => {
                if (checked) {
                    updateUserConfigurationPont(pontType);
                }
                internalToggleIgnoreConversations(
                    actionMessage.rowKeysToIgnore,
                    actionMessage.tableViewId,
                    shouldIgnore,
                    actionMessage.actionSource
                );
            },
            () => {} /* onDismiss */
        );
        dialog.show();
    } else {
        // pont already set, toggle ignore without dialog
        internalToggleIgnoreConversations(
            actionMessage.rowKeysToIgnore,
            actionMessage.tableViewId,
            shouldIgnore,
            actionMessage.actionSource
        );
    }
});

orchestrator(internalToggleIgnoreConversations, actionMessage => {
    const { shouldIgnore, tableViewId, rowKeysToIgnore } = actionMessage;
    const conversationIds: string[] = [];
    const tableView = listViewStore.tableViews.get(tableViewId);

    for (const rowKey of rowKeysToIgnore) {
        conversationIds.push(MailRowDataPropertyGetter.getConversationId(rowKey, tableView));
    }

    if (shouldIgnore) {
        const instrumentationContexts = getInstrumentationContextsFromTableView(
            rowKeysToIgnore,
            tableView
        );
        userMailInteractionAction('Ignore', instrumentationContexts);
    }

    // clean up items client side
    raiseAction<DeleteConversationStoreUpdate>(actionNames.DeleteConversationStoreUpdate)(
        conversationIds,
        tableView
    );

    const ignoreConversationPromise = ignoreConversationsService(
        conversationIds,
        tableView.tableQuery.folderId,
        shouldIgnore
    );

    return processApplyConversationActionResponseMessage(
        ignoreConversationPromise,
        rowKeysToIgnore,
        tableView.tableQuery.folderId,
        tableViewId,
        /*
         * Ignore operation is performed upon delay server-side and not immediately, hence we get
         * row modified notifications while each item in the conversation is getting moved to deleted items folder
         * Hence we do not want to remove this entry from tombstone when action completes, rather we will wait
         * for the rowDelete notification and remove it then which guarantees that the row has been completely
         * moved to deleted items folder
         */
        false /* shouldRemoveRowsFromTombstone */
    );
});
